import React from 'react';
import PropTypes from 'prop-types';

import './InfoToastMessage.scss';

export function InfoToastMessageTitle({ title }) {
  return <div className="info-toast-message__title">{title}</div>;
}

InfoToastMessageTitle.propTypes = {
  title: PropTypes.string,
};

export function InfoToastMessageContent({ content }) {
  return <div className="info-toast-message__content">{content}</div>;
}

InfoToastMessageContent.propTypes = {
  content: PropTypes.string,
};
